<script>
    import { navigate } from "svelte-routing";
    import { getJurisdictions } from "../../../services/jurisdictionService";
    import JurisdictionCard from "./JurisdictionCard.svelte";
    import Table from "../Table.svelte";
    import GroupSearcher from "../../SearchBars/GroupSearcher.svelte";
    import { getGroup } from "../../../services/groupService";
    import { jurisdictionTableFilter } from "../../../stores/jurisdictionTableFilter";
    import { filterDefinedValues } from "../../../utils/filterDefinedValues";
    import { onDestroy, onMount } from "svelte";
    import { createColumnsFromQuery, stringifySortArray } from "../../../utils/sortFunction";
    import Button from "../../Button/Button.svelte";
    import { selectedActiveYear } from "../../../stores/selectedActiveYear";
    import toast from "svelte-french-toast";

    let totalPages;
    let jurisdictions = [];
    let totalCount;
    let isLoading = true;
    let searchedRegion = null;
    let columns = [
        { displayName: "Gruppo", fieldName: "groupName", isSortable: true, sortValue: "desc" },
        { displayName: "Numero comuni", fieldName: "municipalitiesCount" },
        { displayName: "Comuni", fieldName: "municipalities" },
        { displayName: "", fieldName: "" },
    ];

    function updateSortFilter(sorts) {
        $jurisdictionTableFilter = { ...$jurisdictionTableFilter, sort: stringifySortArray(sorts) };
    }

    async function getJurisdictionList(pagination) {
        isLoading = true;

        getJurisdictions(pagination).then((resp) => {
            isLoading = false;

            if (resp.status === 200 && resp?.data) {
                jurisdictions = resp.data.data;

                totalPages = Math.ceil(resp.data?.totalCount / $jurisdictionTableFilter?.size);
                totalCount = resp.data.totalCount;
            }
        }).catch((err) => {
            isLoading = false;

            toast.error(`Errore durante la ricerca, errore: ${err.toString()}`);
        });
    }

    const unsubscribeTableFilter = jurisdictionTableFilter.subscribe((filter) => {
        if (!filter) {
            return;
        }

        const urlSearchParams = new URLSearchParams(filterDefinedValues(filter));
        navigate(!urlSearchParams.size ? "" : `?${urlSearchParams.toString()}`, { replace: false });

        getJurisdictionList(Object.fromEntries(urlSearchParams));
    });

    function updateFilterAndResetPage(key, value) {
        $jurisdictionTableFilter = { ...$jurisdictionTableFilter, page: 1, [key]: value };
    }

    let unsubscribeActiveYear;

    onMount(async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const filters = Object.fromEntries(urlParams);

        if (!filters.page) { filters.page = "1" }
        if (!filters.size) { filters.size = "50" }

        if (!!filters.sort) {
            columns = createColumnsFromQuery(filters.sort, columns);
        }

        if (!!filters.regionId) {
            searchedRegion = (await getGroup(filters.regionId)).data;
        }

        $jurisdictionTableFilter = filters;

        unsubscribeActiveYear = selectedActiveYear.subscribe((year) => {
            $jurisdictionTableFilter = { ...$jurisdictionTableFilter, year };
        });
    });

    onDestroy(() => {
        unsubscribeTableFilter();
        unsubscribeActiveYear();
    });
</script>

{#if !!$jurisdictionTableFilter}
    <Table
        bind:page={$jurisdictionTableFilter.page}
        bind:size={$jurisdictionTableFilter.size}
        bind:totalPages
        bind:totalCount
        bind:isLoading
        bind:rowCount={jurisdictions.length}
        bind:columns
        subject="Sottogruppi"
        on:sort={(e) => updateSortFilter(e.detail)}
    >
        <div class="flex flex-col md:flex-row items-center justify-between w-full gap-2" slot="actions">
            <div class="relative w-full max-w-full font-semibold text-3xl flex-grow flex-1">
                Sottogruppi
            </div>

            <Button
                handleClick="{() => navigate('create', {replace: true})}"
                buttonClass="w-full md:w-44 bg-lightBlue-500 text-white"
                content="Crea sottogruppo"
            />
        </div>

        <div slot="searchbar" class="flex flex-col gap-1 md:flex-row items-end z-10">
            <GroupSearcher
                isUserBased={true}
                isForm={false}
                groupType="REGIONAL"
                placeholder="Regione"
                value="{searchedRegion?.name}"
                on:change={(e) => updateFilterAndResetPage("regionId", e.detail.value)}
                on:clear={() => updateFilterAndResetPage("regionId", undefined)}
            />
        </div>

        <svelte:fragment slot="tableContent">
            {#each jurisdictions as jurisdiction}
                <JurisdictionCard jurisdiction="{jurisdiction}" on:delete={() => getJurisdictionList($jurisdictionTableFilter)} />
            {/each}
        </svelte:fragment>
    </Table>
{/if}
